module.exports = __webpack_public_path__ + "static/media/entrance.ad633e10.svg";